var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-pdf",
    "data-name": "Icon awesome-file-pdf",
    d: "M9.948,14.005a5.276,5.276,0,0,1-.109-2.565C10.3,11.441,10.254,13.459,9.948,14.005Zm-.093,2.581A25.234,25.234,0,0,1,8.3,20.016a20.138,20.138,0,0,1,3.44-1.2A7.084,7.084,0,0,1,9.855,16.587ZM4.709,23.412c0,.044.722-.3,1.909-2.2A7.559,7.559,0,0,0,4.709,23.412ZM13.563,8.75H21V26.688A1.309,1.309,0,0,1,19.688,28H1.313A1.309,1.309,0,0,1,0,26.688V1.313A1.309,1.309,0,0,1,1.313,0H12.25V7.437A1.316,1.316,0,0,0,13.563,8.75Zm-.437,9.4A5.489,5.489,0,0,1,10.79,15.2a7.861,7.861,0,0,0,.339-3.511,1.37,1.37,0,0,0-2.614-.372,9.093,9.093,0,0,0,.443,4.211,51.355,51.355,0,0,1-2.231,4.692c-.005,0-.005.005-.011.005-1.482.76-4.025,2.434-2.98,3.719a1.7,1.7,0,0,0,1.176.547c.979,0,1.952-.984,3.341-3.38a31.173,31.173,0,0,1,4.32-1.269,8.288,8.288,0,0,0,3.5,1.066,1.416,1.416,0,0,0,1.077-2.373c-.76-.744-2.97-.53-4.025-.394Zm7.492-12.4L15.258.383A1.312,1.312,0,0,0,14.328,0H14V7h7V6.666A1.308,1.308,0,0,0,20.617,5.742ZM16.565,19.7c.224-.148-.137-.651-2.341-.492C16.253,20.076,16.565,19.7,16.565,19.7Z",
    fill: "#3d77ca"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.250767a080ec641028113f5baf2286a4.svg";
export { ForwardRef as ReactComponent };